import { render, staticRenderFns } from "./InventoryItemsOverlay.vue?vue&type=template&id=29ab476c&"
import script from "./InventoryItemsOverlay.vue?vue&type=script&lang=ts&"
export * from "./InventoryItemsOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports